import SignUpAuthConfirmModal from './SignUpAuthConfirmModal';

export default SignUpAuthConfirmModal;


// WEBPACK FOOTER //
// ./src/components/SignUpAuthConfirmModal/index.jsx